import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFBAdPreview } from 'redux/modules/adBuilder';
import moment from 'moment';
import adBlocker from 'just-detect-adblock';
import { Dotdotdot, IframePreview, SocialNetworkIcon, Spinner, Stat } from 'components';
import LeadFormPreview from './LeadFormPreview';
import OverviewStats from './OverviewStats';
import * as styles from './AdDetails.scss';
var AdDetailOverview = (_dec = connect(function (state, ownProps) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    facebookAdAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    orgAdBuilder: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)] : {}
  };
}, {
  getFBAdPreview: getFBAdPreview
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdDetailOverview, _Component);

  var _super = _createSuper(AdDetailOverview);

  function AdDetailOverview(props) {
    var _this;

    _classCallCheck(this, AdDetailOverview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getFBAdPreviewWithAdId", function (adId) {
      setTimeout(function () {
        return _this.setState({
          fbAdPreviewRendering: true
        });
      }, 50);

      _this.props.getFBAdPreview(_this.props.organization.id, _this.props.facebookAdAccount.socialAccountId, _this.platformKey(), {
        adId: adId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "platformKey", function () {
      var platformType = _this.props.platformType;

      switch (platformType) {
        case 'instagram':
          return 'INSTAGRAM_STANDARD';

        case 'messenger':
          return 'MESSENGER_MOBILE_INBOX_MEDIA';

        default:
          return 'DESKTOP_FEED_STANDARD';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonBarChange", function (tab) {
      var tabCopy = [].concat(_this.state.leadsButtonBarTabs);
      tabCopy.forEach(function (t) {
        t.selected = t.key === tab.key;
      });

      _this.setState({
        leadsButtonBarTabs: tabCopy
      });
    });

    _this.state = {
      fbAdPreviewRendering: false,
      leadsButtonBarTabs: [{
        title: 'Ad Preview',
        key: 'adPreview',
        selected: true
      }, {
        title: 'Form Preview',
        key: 'formPreview'
      }]
    };
    return _this;
  }

  _createClass(AdDetailOverview, [{
    key: "componentDidMount",
    value:
    /** *********************************************************
     LIFECYCLE METHODS
     ***********************************************************/
    function componentDidMount() {
      var adDetails = this.props.adDetails;
      this.getFBAdPreviewWithAdId(adDetails.id);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.platformType !== this.props.platformType) {
        this.getFBAdPreviewWithAdId(this.props.adDetails.id);
      }
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          platformType = _this$props.platformType;
      var selectedLeadPreview = this.state.leadsButtonBarTabs.find(function (t) {
        return t.selected;
      }).key;

      var platformInsights = _objectSpread({}, adDetails.insights[platformType]);

      var adType = platformInsights.objective;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 48%',
          margin: '0 1%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: selectedLeadPreview === 'formPreview' && adType === 'LEAD_GENERATION' ? {
          display: 'none'
        } : {
          display: 'flex'
        }
      }, adType !== 'EVENT_RESPONSES' ? /*#__PURE__*/React.createElement("div", {
        className: styles.iframeWrap
      }, this.props.loadingFBAdPreview || this.state.fbAdPreviewRendering && /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }), /*#__PURE__*/React.createElement(IframePreview, _extends({
        style: {
          paddingLeft: 16,
          height: '100%'
        },
        iframeWidth: "100%",
        selectedPreviewTab: this.platformKey(),
        onLoad: function onLoad() {
          return _this2.setState({
            fbAdPreviewRendering: false
          });
        },
        organization: this.props.organization
      }, this.props.orgAdBuilder))) : /*#__PURE__*/React.createElement("div", {
        className: styles.iframeWrap,
        style: {
          color: '#333333'
        }
      }, adDetails && adDetails.creative && adDetails.creative.object_story_spec && adDetails.creative.object_story_spec.link_data && adDetails.creative.object_story_spec.link_data.message ? adDetails.creative.object_story_spec.link_data.message.split('\n').map(function (item, key) {
        return /*#__PURE__*/React.createElement("span", {
          key: key
        }, item, /*#__PURE__*/React.createElement("br", null));
      }) : /*#__PURE__*/React.createElement("span", null, adDetails.name)))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 48%',
          margin: '0 1%',
          overflow: 'hidden'
        }
      }, adDetails && adDetails.insights && adDetails.insights[platformType] ? /*#__PURE__*/React.createElement(OverviewStats, {
        platformType: platformType,
        adDetails: adDetails,
        listStyle: {
          margin: 0,
          padding: 0
        },
        style: {
          border: '1px solid #f1f1f1',
          borderRadius: 2,
          flex: 1,
          display: 'flex',
          flexWrap: 'wrap'
        }
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#616161',
          flex: 1,
          textAlign: 'center'
        }
      }, "No results for this ad.")));
    }
  }]);

  return AdDetailOverview;
}(Component), _defineProperty(_class2, "defaultProps", {
  platformType: 'facebook'
}), _temp)) || _class);
export default AdDetailOverview;